import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  searchText: null,
  selectedStatus: null,
  prazoEntregaInicial: null,
  prazoEntregaFinal: null,
  dataEntradaInicial: null,
  dataEntradaFinal: null,
  status: [],
  comprador: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
